// Definitions related to the libraries and syntax documentation system 

export const faustDocURL = "https://faustlibraries.grame.fr/libs";

export const faustSyntaxURL = "https://faustdoc.grame.fr/manual/syntax/";

export const docSections: { [key: string]: string } = {
    aa: "aanl",
    an: "analyzers",
    ba: "basics",
    co: "compressors",
    db: "debug",
    de: "delays",
    dm: "demos",
    dx: "dx7",
    en: "envelopes",
    fd: "fds",
    fi: "filters",
    ho: "hoa",
    hy: "hysteresis",
    it: "interpolators",
    ma: "maths",
    mi: "mi",
    ef: "misceffects",
    mo: "motion",
    no: "noises",
    os: "oscillators",
    pf: "phaflangers",
    pm: "physmodels",
    qu: "quantizers",
    rm: "reducemaps",
    re: "reverbs",
    ro: "routes",
    si: "signals",
    so: "soundfiles",
    sp: "spats",
    sy: "synths",
    ve: "vaeffects",
    vl: "version",
    wa: "webaudio",
    wd: "wdmodels"
};
